
var Coremodule = {
     SyncService          : require('SyncService')
     ,Repository          : require('Repository')
     ,Helpers             : require('Helpers')
     ,Events              : require('ApplicationEvents')
     ,Models              : require('_Models')
     ,States              : require('_States')
     ,Promise             : require('dexie').default.Promise
     ,Store               : require('amplify-store')
     ,Moment              : require('moment')
     ,LocalStorageService : require('LocalStorageService')
     ,Guid                : require('guid')
}


module.exports = Coremodule;
